import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsPanel = ({ onImport, onExport, onBulkEdit }) => {
  const [selectedOperation, setSelectedOperation] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const operationOptions = [
    { value: 'export_all', label: 'Exporter tout le catalogue', icon: 'Download' },
    { value: 'export_category', label: 'Exporter une catégorie', icon: 'FolderDown' },
    { value: 'import_csv', label: 'Importer depuis CSV', icon: 'Upload' },
    { value: 'bulk_price_update', label: 'Mise à jour des prix en masse', icon: 'DollarSign' },
    { value: 'bulk_activate', label: 'Activer plusieurs services', icon: 'CheckCircle' },
    { value: 'bulk_deactivate', label: 'Désactiver plusieurs services', icon: 'XCircle' }
  ];

  const handleExportAll = () => {
    setIsProcessing(true);
    setTimeout(() => {
      const mockData = {
        exportDate: new Date()?.toISOString(),
        totalServices: 156,
        categories: 12,
        format: 'JSON'
      };
      console.log('Exporting catalog:', mockData);
      setIsProcessing(false);
      alert('Catalogue exporté avec succès!\n\nFichier: catalog_export_' + new Date()?.toISOString()?.split('T')?.[0] + '.json');
    }, 1500);
  };

  const handleImport = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv,.json';
    input.onchange = (e) => {
      const file = e?.target?.files?.[0];
      if (file) {
        setIsProcessing(true);
        setTimeout(() => {
          console.log('Importing file:', file?.name);
          setIsProcessing(false);
          onImport({ fileName: file?.name, recordsImported: 45 });
        }, 2000);
      }
    };
    input?.click();
  };

  const handleBulkPriceUpdate = () => {
    const percentage = prompt('Entrez le pourcentage d\'augmentation (ex: 5 pour +5%):');
    if (percentage && !isNaN(percentage)) {
      setIsProcessing(true);
      setTimeout(() => {
        console.log('Updating prices by', percentage + '%');
        setIsProcessing(false);
        onBulkEdit({ operation: 'price_update', percentage: parseFloat(percentage), affectedServices: 89 });
      }, 1500);
    }
  };

  const executeOperation = () => {
    switch (selectedOperation) {
      case 'export_all':
        handleExportAll();
        break;
      case 'export_category':
        alert('Sélectionnez une catégorie dans l\'arborescence puis cliquez sur Exporter');
        break;
      case 'import_csv':
        handleImport();
        break;
      case 'bulk_price_update':
        handleBulkPriceUpdate();
        break;
      case 'bulk_activate': case'bulk_deactivate': alert('Sélectionnez plusieurs services dans l\'arborescence (Ctrl+Clic) puis exécutez l\'opération');
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Layers" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-foreground">
            Opérations en masse
          </h3>
          <p className="text-sm text-muted-foreground">
            Import/Export et modifications groupées
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <Select
          label="Sélectionner une opération"
          options={operationOptions}
          value={selectedOperation}
          onChange={setSelectedOperation}
          placeholder="Choisir une opération..."
        />

        <Button
          onClick={executeOperation}
          disabled={!selectedOperation || isProcessing}
          loading={isProcessing}
          iconName="Play"
          fullWidth
        >
          {isProcessing ? 'Traitement en cours...' : 'Exécuter l\'opération'}
        </Button>

        <div className="grid grid-cols-2 gap-3 pt-4 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            onClick={handleExportAll}
            disabled={isProcessing}
          >
            Export rapide
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Upload"
            onClick={handleImport}
            disabled={isProcessing}
          >
            Import rapide
          </Button>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
          <div className="flex gap-3">
            <Icon name="Info" size={18} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">Formats supportés</p>
              <ul className="list-disc list-inside space-y-1 text-xs">
                <li>CSV: Import/Export de données tabulaires</li>
                <li>JSON: Structure complète du catalogue</li>
                <li>Excel: Compatible avec modèles prédéfinis</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsPanel;